// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Training page */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn:hover {
  background: #4752c4;
}

.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-tabs button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.filter-tabs button.active,
.filter-tabs button:hover {
  background: #5865f2;
  color: white;
}

/* Programs grid */
.programs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}

.program-card {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #5865f2;
  transition: transform 0.2s, box-shadow 0.2s;
}

.program-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.program-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.difficulty-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
}

.difficulty-badge.beginner { background: #43b581; color: white; }
.difficulty-badge.intermediate { background: #faa61a; color: black; }
.difficulty-badge.advanced { background: #f04747; color: white; }

.category-tag {
  color: #72767d;
  font-size: 11px;
  background: #202225;
  padding: 3px 8px;
  border-radius: 12px;
}

.program-name {
  color: #fff;
  margin: 0 0 8px 0;
  font-size: 16px;
}

.program-desc {
  color: #b9bbbe;
  font-size: 13px;
  margin: 0 0 10px 0;
}

.program-meta {
  font-size: 12px;
  color: #72767d;
  margin-bottom: 10px;
}

.program-meta .duration {
  color: #5865f2;
  font-weight: bold;
}

.program-actions {
  display: flex;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #40444b;
}

/* Enrollments */
.enrollments-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.enrollment-card {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #5865f2;
}

.enrollment-card.completed {
  border-left-color: #43b581;
  opacity: 0.8;
}

.enrollment-card.dropped {
  border-left-color: #f04747;
  opacity: 0.7;
}

.enrollment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.enrollment-name {
  color: #fff;
  margin: 0;
  font-size: 16px;
}

.status-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  text-transform: capitalize;
}

.status-badge.active { background: #5865f2; color: white; }
.status-badge.completed { background: #43b581; color: white; }
.status-badge.dropped { background: #f04747; color: white; }

.progress-section {
  margin-bottom: 12px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #202225;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 6px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #5865f2, #43b581);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-text {
  color: #b9bbbe;
  font-size: 12px;
}

.current-task {
  background: #202225;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.current-task .task-label {
  color: #72767d;
  font-size: 11px;
  display: block;
  margin-bottom: 4px;
}

.current-task .task-text {
  color: #dcddde;
  font-size: 13px;
}

.enrollment-actions {
  display: flex;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #40444b;
}

.action-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.action-btn.enroll {
  background: #5865f2;
  color: white;
}

.action-btn.enroll:hover {
  background: #4752c4;
}

.action-btn.complete {
  background: #43b581;
  color: white;
}

.action-btn.complete:hover {
  background: #3aa070;
}

.action-btn.skip {
  background: #faa61a;
  color: black;
}

.action-btn.skip:hover {
  background: #e09515;
}

.action-btn.delete {
  background: #f04747;
  color: white;
}

.action-btn.delete:hover {
  background: #d83c3c;
}

.no-items {
  text-align: center;
  color: #72767d;
  padding: 40px;
  grid-column: 1 / -1;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:hover {
  background: #4752c4;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Training.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,6BAA6B,mBAAmB,EAAE,YAAY,EAAE;AAChE,iCAAiC,mBAAmB,EAAE,YAAY,EAAE;AACpE,6BAA6B,mBAAmB,EAAE,YAAY,EAAE;;AAEhE;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,0BAA0B,mBAAmB,EAAE,YAAY,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;;AAE3D;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Training page */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filter-tabs button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.filter-tabs button.active,\n.filter-tabs button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n/* Programs grid */\n.programs-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 15px;\n}\n\n.program-card {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n  border-left: 4px solid #5865f2;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.program-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.program-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.difficulty-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.difficulty-badge.beginner { background: #43b581; color: white; }\n.difficulty-badge.intermediate { background: #faa61a; color: black; }\n.difficulty-badge.advanced { background: #f04747; color: white; }\n\n.category-tag {\n  color: #72767d;\n  font-size: 11px;\n  background: #202225;\n  padding: 3px 8px;\n  border-radius: 12px;\n}\n\n.program-name {\n  color: #fff;\n  margin: 0 0 8px 0;\n  font-size: 16px;\n}\n\n.program-desc {\n  color: #b9bbbe;\n  font-size: 13px;\n  margin: 0 0 10px 0;\n}\n\n.program-meta {\n  font-size: 12px;\n  color: #72767d;\n  margin-bottom: 10px;\n}\n\n.program-meta .duration {\n  color: #5865f2;\n  font-weight: bold;\n}\n\n.program-actions {\n  display: flex;\n  gap: 8px;\n  padding-top: 10px;\n  border-top: 1px solid #40444b;\n}\n\n/* Enrollments */\n.enrollments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.enrollment-card {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n  border-left: 4px solid #5865f2;\n}\n\n.enrollment-card.completed {\n  border-left-color: #43b581;\n  opacity: 0.8;\n}\n\n.enrollment-card.dropped {\n  border-left-color: #f04747;\n  opacity: 0.7;\n}\n\n.enrollment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.enrollment-name {\n  color: #fff;\n  margin: 0;\n  font-size: 16px;\n}\n\n.status-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  text-transform: capitalize;\n}\n\n.status-badge.active { background: #5865f2; color: white; }\n.status-badge.completed { background: #43b581; color: white; }\n.status-badge.dropped { background: #f04747; color: white; }\n\n.progress-section {\n  margin-bottom: 12px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #202225;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 6px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #5865f2, #43b581);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  color: #b9bbbe;\n  font-size: 12px;\n}\n\n.current-task {\n  background: #202225;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n\n.current-task .task-label {\n  color: #72767d;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.current-task .task-text {\n  color: #dcddde;\n  font-size: 13px;\n}\n\n.enrollment-actions {\n  display: flex;\n  gap: 8px;\n  padding-top: 10px;\n  border-top: 1px solid #40444b;\n}\n\n.action-btn {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n}\n\n.action-btn.enroll {\n  background: #5865f2;\n  color: white;\n}\n\n.action-btn.enroll:hover {\n  background: #4752c4;\n}\n\n.action-btn.complete {\n  background: #43b581;\n  color: white;\n}\n\n.action-btn.complete:hover {\n  background: #3aa070;\n}\n\n.action-btn.skip {\n  background: #faa61a;\n  color: black;\n}\n\n.action-btn.skip:hover {\n  background: #e09515;\n}\n\n.action-btn.delete {\n  background: #f04747;\n  color: white;\n}\n\n.action-btn.delete:hover {\n  background: #d83c3c;\n}\n\n.no-items {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n  grid-column: 1 / -1;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
